var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnknownFileExtension = function SvgUnknownFileExtension(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#unknownFileExtension_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.7 46.282h32.572a.86.86 0 0 0 .858-.857V11.997h-7.715a2.575 2.575 0 0 1-2.571-2.572V1.711H2.7a.86.86 0 0 0-.857.857v42.857a.86.86 0 0 0 .857.857"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m34.922 10.285-7.36-7.36v6.503a.86.86 0 0 0 .858.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M37.116 10.034 27.836.75a2.6 2.6 0 0 0-1.818-.753H2.728A2.575 2.575 0 0 0 .156 2.569v42.858a2.575 2.575 0 0 0 2.572 2.571h32.571a2.575 2.575 0 0 0 2.572-2.571V11.85c0-.686-.268-1.332-.755-1.818m-9.531-7.11 7.36 7.36h-6.503a.86.86 0 0 1-.857-.857zM2.728 46.284h32.571a.86.86 0 0 0 .857-.857V11.998h-7.714a2.575 2.575 0 0 1-2.572-2.571V1.712H2.729a.86.86 0 0 0-.857.857v42.858c0 .473.384.857.857.857",
    clipRule: "evenodd",
    opacity: 0.67
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "unknownFileExtension_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.156-.002H37.87v48H.156z"
  })))));
};
export default SvgUnknownFileExtension;